import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { CertPdfChkDetail, PatentRightsDetail } from 'src/types/api/patentRightsApiTypes';
import { Table, TopItem, Title, Content } from 'src/components/contents/detail/DetailPage';
import RightsEffectiveTag, {
  RightsEffectStatus,
} from 'src/components/layout/tag/RightsEffectiveTag';
import { stringToDate } from 'src/utils/formatters';
import PdfDownloadPatent from './PdfDownloadPatent';

interface Iprops {
  data: PatentRightsDetail;
  certPdfChkDetail: CertPdfChkDetail;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利案件基本資訊。
 */
const InfoPatentRightBase: React.FC<Iprops> = ({
  data,
  certPdfChkDetail,
  isShow,
  setIsShow,
  colorType,
  noContent,
}) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;

  // 取得權利當前狀態
  const rightsStatus = () => {
    let result = RightsEffectStatus.None;
    if (data.patentRight.patentStartDate && data.patentRight.patentEndDate) {
      const tmp_expired = stringToDate(data.patentRight.patentEndDate);
      const now = new Date();
      if (data.patentRight.cancelDate || data.patentRight.cancelResult || data.patentRight.revokeDate || data.patentRight.revokeCode) {
        result = RightsEffectStatus.InEffective;
      } else if (
        !data.patentRight.cancelResult &&
        tmp_expired &&
        tmp_expired.getTime() >= now.getTime()
      ) {
        result = RightsEffectStatus.Effective;
      }
    }
    return result;
  };

  return (
    <DropdownInfo
      title={`專利證書號數：${data.patentRight.patentNo}`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      <Table color={tableColor}>
        <TopItem>
          <Title>專利名稱</Title>
          <Content>{data.patentTitle.patentNameChinese || noContent}</Content>
        </TopItem>
        <TopItem>
          <Title>專利權人</Title>
          <Content>
            {data.applicants.length !== 0
              ? data.applicants.map((item, index) => {
                  index += 1;
                  return index !== data.applicants.length
                    ? item.chineseName + '、'
                    : item.chineseName;
                })
              : noContent}
          </Content>
        </TopItem>
        <TopItem>
          <Title>發明人</Title>
          <Content>
            {data.inventors.length !== 0
              ? data.inventors.map((item, index) => {
                  index += 1;
                  return index !== data.inventors.length
                    ? item.chineseName + '、'
                    : item.chineseName;
                })
              : noContent}
          </Content>
        </TopItem>
        <TopItem>
          <Title>專利權期間</Title>
          <Content>
            自{data.patentRight.patentStartDate}至{data.patentRight.patentEndDate}止
            <RightsEffectiveTag status={rightsStatus()} content={data.patentRight.cancelResult || data.patentRight.revokeResult} />
          </Content>
        </TopItem>
      </Table>
      <Table color={tableColor}>
        <TopItem>
          <Title>專利證書</Title>
          <Content>
            <PdfDownloadPatent
              data={data}
              certPdfChkDetail={certPdfChkDetail}
              colorType={colorType}
              noContent={noContent}
            />
          </Content>
        </TopItem>
      </Table>
    </DropdownInfo>
  );
};

export default InfoPatentRightBase;
